import PartnerChildrenList from './PartnerChildrenList'

export default PartnerChildrenList



// WEBPACK FOOTER //
// ./src/views/PersonalInfo/components/PartnerChildren/index.js